<template>
   <div class="container">
       

        <div class="row">
            <div class="product-btn col-24" style="text-align:center" >
              <br><br>
            <h3>Online reservatie is tijdelijk gesloten.<br>Probeer het later nog eens aub.</h3>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../store/mutation-types'

 export default {
    name: 'startup',
    components: {
    },
     data () {
      return {

      }
    },
    computed: {
      isAppError () {

          this.$store.commit(SPINNER_HIDE);
          return Vue.$errorStartup;
      }
    },
    methods: {
       
    },
    updated() {
        this.$store.commit(SPINNER_HIDE);
    }
   
  }
</script>


// WEBPACK FOOTER //
// src/pages/StoreClosed.vue